module.exports = __webpack_public_path__ + "img/20210126_150522.002e66c0.jpg";